import { Modal } from '@ui/components/layout/Modal';
import { useGlobalState } from '@ui/state/global';

export function ModalLayout() {
  const { activeModal } = useGlobalState();

  return <Modal isOpen={!!activeModal} {...activeModal} />;
}
